import styled from "@emotion/styled";
import {
  FormProps,
  getBaseColor,
  animatedFontStyle,
  disabledTextStyle,
} from "./utils";

const Hint = styled.span<FormProps>`
  position: absolute;
  transition: all 200ms ease;
  right: 0rem;
  color: ${getBaseColor("gray20")};
  ${animatedFontStyle}
  ${disabledTextStyle}
`;

export default Hint;
